// removed by extract-text-webpack-plugin
module.exports = {"col":"Col__col___3cVp4"};


//////////////////
// WEBPACK FOOTER
// ./src/components/enterprise/EnterpriseGrid/Col/Col.scss
// module id = 1012
// module chunks = 0